import React, {useEffect, useState} from 'react';
import CustomList from './CustomList';
import CustomManagerInformation from './CustomManagerInformation';
import './CustomManagerMain.css';

const CustomManagerMain = (props) => {
  const [customLabelData, setCustomLabelData] = useState();

  useEffect(()=>{
    setCustomLabelData(props.customLabelData);
  }, [props.customLabelData]);

  return (
    <div className="row featured-main">
      <div className="manageReportBoxLR">
        <table width="100%" border="0" cellspacing="0" cellpadding="0">
          <tr>
            <td width="22%" valign="top">
                {customLabelData &&
                  <div id="manageReportLeft">
                    <CustomList handleClick={props.handleClick} customLabelData={customLabelData}
                      handleSearchBtn={props.handleSearchBtn} reportFilter={props.reportFilter} handleSearchInput={props.handleSearchInput} filteredArray={props.filteredArray}
                    />
                  </div>
                }
            </td>
            <td width="78%" valign="top">
            <div id="manageReportRight">
              <CustomManagerInformation 
                handleRemoveBtn={props.handleRemoveBtn} 
                selectedCustom={props.selectedCustom} selectedCustomQueryArray={props.selectedCustomQueryArray} queryData={props.queryData} 
              />
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  )
}

export default CustomManagerMain;